module.exports = __webpack_public_path__ + "static/img/Tours.247c675.png";